import { Modal } from "../ui/components/Modal";
import api from "../api";

export class CreateFolderModal extends Modal {
    isSubmitting = false;

    init() {
        super.init();
        this.includeComponents({
            authModal: "document@#authModal",
        });

        this.cancelBtn.on("click", () => {
            this.hide();
        });

        this.input.on("keyup", this.onInputChange.bind(this));
        this.input.on("change", this.onInputChange.bind(this));

        this.submitBtn.on("click", this.onSubmit.bind(this));
    }

    show() {
        this.input.value("");
        this.submitBtn.disable();
        super.show();
    }

    onInputChange(e) {
        if (e?.keyCode === 13) {
            this.onSubmit();
            return;
        }

        if (this.input.element.value.trim().length > 0) {
            this.submitBtn.enable();
        } else {
            this.submitBtn.disable();
        }
    }

    async onSubmit() {
        if (this.isSubmitting) return;

        const name = this.input.value().trim(); 
        if (!name) {
            this.submitBtn.disable();
            return;
        }

        this.isSubmitting = true;

        try {
            const response = await api.post("/api/folders", {
                name,
                redirect: true,
            });
            
            this.hide();
            
        } catch (error) {
            this.errorBag.show(error);
        } finally {
            this.isSubmitting = false;
        }
    }
}